import { render, staticRenderFns } from "./DeferInfo.vue?vue&type=template&id=1fa91898"
import script from "./DeferInfo.vue?vue&type=script&lang=js"
export * from "./DeferInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports